export const FileIcons = {
  doc: 'file-word',
  ppt: 'file-powerpoint',
  xls: 'file-excel',
  pdf: 'file-pdf',
  image: 'file-image',
};
